import React, { FC } from 'react';
import SVGUniqueID from 'react-svg-unique-id';

interface SVGComponentProps {
    width?: number;
    height?: number;
}

const BlueTickIcon: FC<SVGComponentProps> = ({ width = 16, height = 16 }) => {
    return (
        <SVGUniqueID>
            <svg
                width={width}
                height={height}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 14.4A6.4 6.4 0 108 1.6a6.4 6.4 0 000 12.8zm2.966-7.434a.8.8 0 00-1.132-1.132L7.2 8.47 6.166 7.434a.8.8 0 10-1.132 1.132l1.6 1.6a.8.8 0 001.132 0l3.2-3.2z"
                    fill="#2563EB"
                />
            </svg>
        </SVGUniqueID>
    );
};

export { BlueTickIcon };

